import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
} from '@mui/material';
import {policyTransactionHistoryAction} from '../../../redux/actions/transactionHistoryAction'
import { useDispatch, useSelector } from 'react-redux';

const TransactionHistory = ({policyId}) => {
  const dispatch = useDispatch();
  const policy_history = useSelector((state) => state?.policyTransactionHistory?.transaction_history.content || []);
  
  const pagination_history = useSelector((state) => state?.policyTransactionHistory?.transaction_history || []);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if(policyId){
      dispatch(policyTransactionHistoryAction(policyId, page, rowsPerPage));    
    }    
  }, [policyId])
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow className="styled-table-row">
              <TableCell className="styled-table-heading" sx={{fontWeight: 'bold'}}>
                <Typography id="transaction" variant="subtitle1" color="black">Transaction</Typography>
              </TableCell>
              <TableCell className="styled-table-heading" sx={{fontWeight: 'bold'}}>
                <Typography id="entrydate" variant="subtitle1" color="black">Entry Date</Typography>
              </TableCell>
              <TableCell className="styled-table-heading" sx={{fontWeight: 'bold'}}>
                <Typography id="effdate" variant="subtitle1" color="black">Eff Date</Typography>
              </TableCell>
              <TableCell className="styled-table-heading" sx={{fontWeight: 'bold'}}>
                <Typography id="amount" variant="subtitle1" color="black">Amount</Typography>
              </TableCell>
              <TableCell className="styled-table-heading" sx={{fontWeight: 'bold'}}>
                <Typography id="commission" variant="subtitle1" color="black">Commission</Typography>
              </TableCell>
              <TableCell className="styled-table-heading" sx={{fontWeight: 'bold'}}>
                <Typography id="policypremium" variant="subtitle1" color="black">Policy Premium</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {policy_history.map((transaction, index) => (
              <TableRow key={index}  className="styled-table-row">
                <TableCell>{transaction.type}</TableCell>
                <TableCell>{transaction.entryDate}</TableCell>
                <TableCell>{transaction.effDate}</TableCell>
                <TableCell>{transaction.amount}</TableCell>
                <TableCell>{transaction.commission}</TableCell>
                <TableCell>{transaction.premium}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={pagination_history.totalPages > 0 ? [5, 10, 15, 25, 50, 100] : []}
        component="div"
        count={pagination_history.totalElements || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default TransactionHistory;
